"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Banner = _interopRequireDefault(require("./Banner"));

var _Button = _interopRequireDefault(require("./button/Button"));

var _StringOrRender = _interopRequireDefault(require("./helper/StringOrRender"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RichTextBanner = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RichTextBanner, _Component);

  var _super = _createSuper(RichTextBanner);

  function RichTextBanner() {
    var _this;

    (0, _classCallCheck2["default"])(this, RichTextBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(RichTextBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sentiment = _this$props.sentiment,
          title = _this$props.title,
          description = _this$props.description,
          buttonText = _this$props.buttonText,
          contentAlignment = _this$props.contentAlignment,
          iconVerticalAlignment = _this$props.iconVerticalAlignment,
          onClick = _this$props.onClick,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement(_Banner["default"], {
        className: (0, _styling.css)(className),
        sentiment: sentiment,
        showTopBorder: true,
        contentAlignment: contentAlignment,
        iconVerticalAlignment: iconVerticalAlignment
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleText)
      }, title), /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: description
      }), buttonText && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.buttonStyle)
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: onClick,
        text: buttonText,
        padding: "6px 12px"
      }))));
    }
  }, {
    key: "styles",
    get: function get() {
      var fonts = this.context.theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        },
        buttonStyle: {
          marginTop: 12
        },
        titleText: {
          fontFamily: fonts.bold,
          margin: "5px 0px"
        }
      });
    }
  }]);
  return RichTextBanner;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  sentiment: {
    required: true,
    type: "\"success\" | \"warning\" | \"error\" | \"info\"",
    description: "Sentiment of the banner message"
  },
  title: {
    required: true,
    type: "string",
    description: "Banner title"
  },
  description: {
    required: false,
    defaultValue: "null",
    type: "string",
    description: "Optional banner description"
  },
  buttonText: {
    required: false,
    defaultValue: "null",
    type: "string | null | undefined",
    description: "If the banner should have a button, " + "use this prop to set the button's text."
  },
  contentAlignment: {
    required: false,
    defaultValue: "center",
    type: "\"left\" | \"center\"",
    description: "Whether to center the content or left align it"
  },
  iconVerticalAlignment: {
    required: false,
    defaultValue: "center",
    type: "\"top\" | \"center\"",
    description: "Whether to center the icon or top align it"
  },
  onClick: {
    required: false,
    defaultValue: "null",
    type: "?() => mixed",
    description: "If the banner has a button, " + "this value is the callback for when the button is clicked"
  }
}, _class3.demoProps = [{
  demoDescription: "success",
  sentiment: "success",
  title: "Thanks for your submission!",
  description: "You shall be hearing from us shortly " + "in approximately 3-5 business days.",
  buttonText: "Make a payment"
}, {
  demoDescription: "warning",
  sentiment: "warning",
  title: "Product was detected to contain Intellectual Property " + "belonging to APPLE Inc.",
  description: "This product listing contains a direct copy or imitation " + "of a brand's logo, design or uses copyrighted images belonging to " + "others.",
  buttonText: "Review item"
}, {
  demoDescription: "error",
  sentiment: "error",
  title: "Authorization will be requested for branded items.",
  description: "Branded items are welcome on Wish. All you have to do is " + "provide authorization.",
  buttonText: "Provide authorization"
}, {
  demoDescription: "info",
  sentiment: "info",
  title: "Your next payment amount 726.05 is scheduled to be paid on " + "Jan 01, 2018.",
  description: "You will receive the payment in the form of a cheque from " + "Bill.com. Please allow 5-21 days to receive this cheque.",
  buttonText: "Enter bank details"
}], _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

exports["default"] = RichTextBanner;